import { useEffect, useState } from "react";

import Tabs from "../Tabs/Tabs";

import { NavLink } from "react-router-dom";
import DefaultWalletProvider from "./DefaultWalletProvider";
import { appInsights } from "../../config/appInsights";
// import AllWallet from "./AllWallet";

const Wallet = () => {
  const [activeTab, setActiveTab] = useState("wallet-provider");

  useEffect(() => {
    appInsights.trackPageView({
      name: "Wallet Provider - (Wallet.jsx)",
      isLoggedIn: true,
    });
  }, []);

  const tabs = [
    {
      identifier: "walletManagerTab",
      name: "Wallet Providers",
      id: "wallet-provider",
    },
    // {
    //   identifier: "walletManagerTab",
    //   name: "Wallets",
    //   id: "all-wallets",
    // },
  ];

  return (
    <div className="datatable-wrapper">
      <div className="table-view animated speed-1x fadeInRight">
        <div className="row grid__padding animated fadeInRight">
          <div className="col-lg-12 col-md-12 col-sm-12 dashboard-title flex__row">
            <h3 className="m-l-1 relax-left">
              <aside className="rounder">
                <i className="fas fa-check-circle" />
              </aside>
              &nbsp; Wallet
            </h3>
            <div className="breadcrumb__location">
              <NavLink to="dashboard">
                <h3 className="breadcrumb__location__title ">Dashboard</h3>
              </NavLink>
              <span className="breadcrumb__location__icon">
                <i className="fas fa-angle-double-right" />
              </span>
              <NavLink to="manage-approvals">
                <h3 className="breadcrumb__location__title">Wallet</h3>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="row m-x-1 m-t-md">
          <Tabs onContentToggle={(e) => setActiveTab(e)} tabs={tabs} />
        </div>
        {/* main Tabs*/}
        {(() => {
          switch (activeTab) {
            case "wallet-provider":
              return <DefaultWalletProvider />;

            // case "all-wallets":
            //   return <AllWallet />;

            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

export default Wallet;
